export const defaultEventTemplate = (baseDate: Date = new Date()) => `{
  "actualDateTime": "${baseDate.toISOString()}",
  "code": "",
  "eventType": "",
  "domain": "BUSINESS",
  "description": "",
  "reasonCode": "",
  "location": {
    "locationName": "",
    "locationType": "",
    "code": "",
    "address": {
      "addressLocality": "",
      "addressRegion": "",
      "postOfficeBoxNumber": "",
      "postalCode": "",
      "addressLines": [],
      "addressCountry": {
        "countryCode": "",
        "countryName": ""
      }
    },
    "contacts": [],
    "documents": [],
    "externalReferences": [],
    "geolocation": {
      "geolocationUnit": "",
      "elevation": {
        "unit": "",
        "value": 0
      },
      "latitude": {
        "unit": "",
        "value": 0
      },
      "longitude": {
        "unit": "",
        "value": 0
      }
    },
    "specialCharacteristics": [],
    "specialInstructions": []
  },
  "createdBy": {
    "commercialName": "",
    "legalEntityName": "",
    "address": {
      "addressLocality": "",
      "addressRegion": "",
      "postOfficeBoxNumber": "",
      "postalCode": "",
      "addressLines": [],
      "addressCountry": {
        "countryCode": "",
        "countryName": ""
      }
    },
    "companyRegistrationIds": []
  },
  "accountableParty": {
    "commercialName": "",
    "legalEntityName": "",
    "address": {
      "addressLocality": "",
      "addressRegion": "",
      "postOfficeBoxNumber": "",
      "postalCode": "",
      "addressLines": [],
      "addressCountry": {
        "countryCode": "",
        "countryName": ""
      }
    },
    "companyRegistrationIds": []
  },
  "documents": [
    {
      "cmsUri": "",
      "documentName": "",
      "format": "",
      "isRequired": false,
      "suppliedWithGoods": false,
      "documentType": "",
      "documentSubtype": ""
    }
  ]
}`;
